import { useEffect } from "react";
import { useApolloClient } from "@apollo/client";
import { GET_CLASSROOM_LIST } from "../../AdminDashboard/api/AdminDashboardQuery";
import { GET_ALL_CLASSROOM_IDS } from "../api/AdminAnnouncementQuery";

export const CLASSROOM_PAGE_SIZE = 20;

// The form reads these with cache-first, so the variables must match exactly for a cache hit
export const classroomListVariables = (offset: number) => ({
  orderBy: ["C_NAME_ASC"],
  searchInput: "%%",
  limit: CLASSROOM_PAGE_SIZE,
  offset,
});

/**
 * Warms the Apollo cache (first classroom page + all ids) so the announcement form's classroom options
 * and "Select All Classrooms" are ready when the form opens.
 */
export const useClassroomOptionsPrefetch = (enabled: boolean) => {
  const client = useApolloClient();

  useEffect(() => {
    if (!enabled) return;
    client
      .query({ query: GET_CLASSROOM_LIST, variables: classroomListVariables(0), fetchPolicy: "network-only" })
      .catch(() => undefined);
    client.query({ query: GET_ALL_CLASSROOM_IDS, fetchPolicy: "network-only" }).catch(() => undefined);
  }, [enabled, client]);
};
